import { render, staticRenderFns } from "./LocationManageSave.vue?vue&type=template&id=54dbffe5&scoped=true"
import script from "./LocationManageSave.vue?vue&type=script&lang=js"
export * from "./LocationManageSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dbffe5",
  null
  
)

export default component.exports